export const PRIVATE_TRADE_LANE_CITY_POSTAL_COUNTRIES = [
  "US",
  "CA",
  "MX",
  "AU",
];

export const isPrivateTradeLaneCityPostalCountry = (countryCode) =>
  PRIVATE_TRADE_LANE_CITY_POSTAL_COUNTRIES.includes(countryCode);

const defaultZipCodeRules = (
  countriesWithoutZipCode,
  isBusiness,
  countryCode
) => ({
  pattern: "[A-Za-z0-9\\s\\-\\/]{1,10}",
  required:
    isBusiness || isPrivateTradeLaneCityPostalCountry(countryCode)
      ? typeof countriesWithoutZipCode[countryCode] === "undefined"
      : false,
});

const defaultCityRules = (isBusiness, hasPostalCode, countryCode) => ({
  required:
    (isBusiness || isPrivateTradeLaneCityPostalCountry(countryCode)) &&
    !hasPostalCode,
});

const validationRules = {
  originCountry: {
    type: "string",
    defaultRule: {
      pattern: "^([A-zÀ-ÿ0-9’.-]+\\s)*[\\(\\)A-zÀ-ÿ0-9’.-]+$",
      required: true,
    },
  },

  originZip: {
    type: "string",
    getDefaultRule: defaultZipCodeRules,
  },

  originCity: {
    type: "string",
    getDefaultRule: defaultCityRules,
  },

  destinationCountry: {
    type: "string",
    defaultRule: {
      pattern: "^([A-zÀ-ÿ0-9’.-]+\\s)*[\\(\\)A-zÀ-ÿ0-9’.-]+$",
      required: true,
    },
  },

  destinationZip: {
    type: "string",
    getDefaultRule: defaultZipCodeRules,
  },

  destinationCity: {
    type: "string",
    getDefaultRule: defaultCityRules,
  },
};

export default validationRules;
